module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.81b75cfd.png";